var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("a", { ref: "attachmentA" }),
      _vm._v(" "),
      _c("stepheader", { attrs: { step: _vm.step } }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "body current",
          attrs: {
            id: "wizard2-p-0",
            role: "tabpanel",
            "aria-labelledby": "wizard2-h-0",
            "aria-hidden": "false",
          },
        },
        [
          _c(
            "div",
            { staticClass: "row" },
            _vm._l(
              _vm.attachments.filter(
                (x) => x.attachmentTypeId == _vm.attachmentTypeUpload
              ),
              function (item) {
                return _c(
                  "div",
                  {
                    key: item.attachmentId,
                    staticClass: "col-xl-3 col-md-6 col-sm-6 my-1",
                  },
                  [
                    _c("div", { staticClass: "card m-0 p-0 border" }, [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center px-3 pt-3" },
                        [
                          _c("div", { staticClass: "float-end ms-auto" }, [
                            _vm._m(0, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "dropdown-menu dropdown-menu-start",
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    attrs: { href: "#" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.removeAttachment(
                                          item.attachmentId
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fe fe-trash me-2",
                                    }),
                                    _vm._v(" Elimina"),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-body pt-0 text-center" }, [
                        _c("div", { staticClass: "file-manger-icon" }, [
                          _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.downloadAttachment(
                                    item.attachmentId,
                                    item.originalFileName
                                  )
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa-3x br-7 p-2",
                                class: _vm.getExtensionIcon(item.fileExtension),
                                attrs: { src: "" },
                              }),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("h6", { staticClass: "mb-1 font-weight-semibold" }, [
                          _vm._v(_vm._s(item.title)),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-muted" }, [
                          _vm._v(_vm._s(_vm._f("prettyBytes")(item.weight))),
                        ]),
                      ]),
                    ]),
                  ]
                )
              }
            ),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c(
                  "vue-dropzone",
                  {
                    ref: "myVueDropzone",
                    attrs: {
                      id: "attachment-dropzone",
                      name: "attachment-dropzone",
                      options: _vm.dropzoneOptions(),
                      useCustomSlot: true,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "dropzone-custom-content dropify-message",
                      },
                      [
                        _c("h3", { staticClass: "dropzone-custom-title" }, [
                          _vm._v(
                            "\n                          Trascina i file qui per il caricamento\n                      "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "subtitle" }, [
                          _vm._v("...o fai click per caricarlo dal tuo pc"),
                        ]),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("buttons", {
            attrs: { buttons: _vm.step.buttons },
            on: { action: _vm.fireaction },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "option-dots",
        attrs: {
          href: "#",
          "data-bs-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false",
        },
      },
      [_c("i", { staticClass: "fe fe-more-vertical" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }